import { Box, Typography } from '@mui/material';
import React from 'react';
import Metadata from '../../components/Metadata/Metadata';
import Section from '../../components/Section/Section';
import Hero from '../../components/Hero/Hero';

const PageContent: React.FC = () => {
  return (
    <Box>
      <Metadata
        title="Contact Us Success | General Genomics"
        description="Get in touch with General Genomics for inquiries, demos, and business opportunities. Our Contact page makes it easy to connect and take the next step in your journey."
      />
      <Hero helper="Contact Us" headline="Get in touch with General Genomics" />
      <Section className="cards-large-icons">
        <Typography variant="h2" className="action-on-view action-fade-in">
          Thank You for Reaching Out
        </Typography>
        <Typography className="action-on-view action-fade-in">
          We appreciate your interest in General Genomics. A member of our team
          will contact you shortly to discuss your needs and provide the
          information you’re looking for. We look forward to connecting with
          you!
        </Typography>
      </Section>
    </Box>
  );
};

export default PageContent;
